import { Directive, Input, TemplateRef } from '@angular/core';

import { DocumentsCellContext } from './documents-table-column.model';

/**
 * Registers an inline cell template for the documents-table by key.
 * Usage:
 *   <rnpl-documents-table [columns]="columns" [rows]="rows">
 *     <ng-template rnplCol="partner" let-row="row" let-value="value"> ... </ng-template>
 *   </rnpl-documents-table>
 * The key must match `cell` in the corresponding column config.
 */
@Directive({
  selector: 'ng-template[rnplCol]'
})
export class RnplColDirective {
  @Input('rnplCol') public key: string;

  constructor(public readonly template: TemplateRef<DocumentsCellContext>) {}

  static ngTemplateContextGuard(
    dir: RnplColDirective,
    ctx: unknown
  ): ctx is DocumentsCellContext {
    return true;
  }
}
